module.exports = __webpack_public_path__ + "static/media/coursel_asset_2.9b277350.jpg";